<template>
  <div class="container-fluid">
    <div class="row">
      <!--
      <div class="col-md text-left">
        <b-form-select v-model="currentMode" :options="options" class="md" size="sm" />
      </div>
      -->
      <div class="col-md last-update" v-bind:class="{'text-right': window.isMobile != true,'text-center': window.isMobile == true}">{{$t("UpdateTime")}}{{lastUpdate}}</div>
    </div>
    <div>
      <div class="col-md text-center">
        
        <b-button-group>
          <b-button size="sm" 
            v-for="btn in options" 
            :key="btn.value" 
            v-on:click="currentMode = btn.value" :variant="currentMode == btn.value ? 'info' : ''"
            v-b-tooltip.hover :title="$t('button.'+btn.value+'.title')" placement="bottom"
            >
            {{$t('button.'+btn.value+'.text')}}
          </b-button>
        </b-button-group>
      </div>
    </div>
    <div class="row">
          <div class="col-md control-button" v-bind:class="{'text-right': !window.isMobile, 'text-center': window.isMobile}">
              <button type="button" class="btn btn-control" @click="simpleMode = !simpleMode">
                  <i class="fas fa-angle-double-down" v-bind:class="{'fa-angle-double-down': simpleMode==true, 'fa-angle-double-up':simpleMode==false}"></i>{{simpleMode?$t("AllTaiwan.EnableMore"):$t("AllTaiwan.DisableMore")}}
              </button>
          </div>
    </div>
    <div class="row">
      <EachRegionComponent 
        :simpleMode="simpleMode"
        isNeededShowLegend="true" 
        series="Greater_Taipei" 
        ref="Greater_Taipei" 
        :WeekSelectValue="WeekSelectValue"
        @ChangedWeekSelectValue="onWeekSelectValue"
        :mode="currentMode" 
        v-if="currentMode"></EachRegionComponent>
      <EachRegionComponent 
        :simpleMode="simpleMode"
        series="North_Area" 
        ref="North_Area" 
        :mode="currentMode" 
        :WeekSelectValue="WeekSelectValue"
        @ChangedWeekSelectValue="onWeekSelectValue"
        v-if="currentMode"></EachRegionComponent>
      <EachRegionComponent 
        :simpleMode="simpleMode"
        series="Central_Area" 
        ref="Central_Area" 
        :mode="currentMode" 
        :WeekSelectValue="WeekSelectValue"
        @ChangedWeekSelectValue="onWeekSelectValue"
        v-if="currentMode"></EachRegionComponent>
    </div>
    <div class="row">
      <EachRegionComponent 
        :simpleMode="simpleMode"
        series="South_Area" 
        ref="South_Area" 
        :mode="currentMode" 
        :WeekSelectValue="WeekSelectValue"
        @ChangedWeekSelectValue="onWeekSelectValue"
        v-if="currentMode"></EachRegionComponent>
      <EachRegionComponent 
        :simpleMode="simpleMode"
        series="Kao_Ping" 
        ref="Kao_Ping" 
        :mode="currentMode" 
        :WeekSelectValue="WeekSelectValue"
        @ChangedWeekSelectValue="onWeekSelectValue"
        v-if="currentMode"></EachRegionComponent>
      <EachRegionComponent 
        :simpleMode="simpleMode"
        series="East_Area" 
        ref="East_Area" 
        :mode="currentMode"
        :WeekSelectValue="WeekSelectValue"
        @ChangedWeekSelectValue="onWeekSelectValue" 
        v-if="currentMode"></EachRegionComponent>
    </div>
  </div>
</template>

<script>
import EachRegionComponent from "./EachRegionComponent";
import Vue from 'vue';

export default {
  name: 'EachRegion',
  components: { EachRegionComponent },
  data () {
    return {
      window: window,
      lastUpdate: undefined,
      lastWeek: "...",
      currentMode: 'RODS_NHI',
      WeekSelectValue: 52,
      simpleMode: true,
      options: [
        {value:'RODS_NHI', text: '總就診人次', title: "來源：健保資料庫+RODS"},
        {value:'NHI', text: '門診', title: "來源：健保資料庫"},
        {value:'RODS', text: '急診', title: "來源：RODS"},
      ]
    }
  },
  methods: {
    getLastUpdate: function(){
      Vue.axios.get(`https://fluforecast.cdc.gov.tw/WebService/getFileUpdateTimeEachRegion.php`).then((res)=>{
        if(res.status != 200){

        }
        else{
            this.lastUpdate = res.data;
        }
      })
    },
    onWeekSelectValue: function(updatedWeekSelectValue){
      this.WeekSelectValue = updatedWeekSelectValue;
    },
    routeChange: function(){
      if(this.$route.params.Region_Eng){
        document.body.scrollTop = this.$refs[this.$route.params.Region_Eng].$el.offsetTop - 60
      }
    }
  },
  mounted: function(){
    this.getLastUpdate();
    //Scroll to specific region
    setTimeout(()=>{
      this.routeChange();
    },1500)

    //this.getLastWeek();
  },
  watch: {
    currentMode: function(){
      this.$ga.event({
        eventCategory: 'EachRegion',
        eventAction: 'ChangeType',
        eventLabel: this.currentMode
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .last-update{
      font-size: 14px;
  }

  * {
    color: #FFF
  }

  .row{
    margin: 8px 0px;
  }

  .container-fluid {
    padding: 0px;
    max-width: 1920px;
  }

  select{
    color: #000
  }

  .control-button{
      &.text-center{
          padding-top: 18px;
      }
      button{
          display: inline-flex;
              
          background: rgba(0,0,0,0);
          color: #FFF;
          font-size: 14px;
          border-color: #FFF;
          border-radius: 50px;
          i{
              font-size: 20px;
              padding-right: 4px;
          }

          &:hover{
              background-color: #FFF;
              color: #000;
              i{
                color: #000;
              }
          }
      }
  }
</style>




// WEBPACK FOOTER //
// src/components/EachRegion.vue